const state = {
    items: []
}

const mutations = {
    storeNewsEvents (state, payload) {
        state.items = payload
    },
    addNewsEvent (state, payload) {
        state.items.unshift(payload.data)
    },
    updateNewsEvent (state, payload) {
        let newsEvent = state.items.find(item => item.id === payload.data.id)
        newsEvent = payload.data
    },
    newsEventChangeState (state, payload) {
        let newsEvent = state.items.find(item => item.id === payload.data.id)
        newsEvent.status = payload.data.status
    },
    deleteNewsEvent (state, payload) {
        state.items = state.items.filter(item => item.id !== payload.id)
    }
}

const actions = {}

const getters = {
    getNews: state => state
}

export default {
    state,
    mutations,
    actions,
    getters
}
